module.exports = __webpack_public_path__ + "static/media/sudoku1.f4c4a819.png";